export class AddOrEditCaseAssignmentType {
    id: number;
    name: string;
    defaultName: string;
    isUpdateNoticesEnabled: boolean;
    isAssignmentNoticesEnabled: boolean;
    isConfirmAssignmentNoticesEnabled: boolean;
    isAssignToReopenEnabled: boolean;
}